import {
  MetafieldSelectedsOrErrorListV2Type,
  MetafieldSelectedV2Dto,
} from '@tiendanube/common';
import {
  DeleteMetafieldsRequest,
  UpsertMetafieldsRequest,
} from '@tiendanube/common/src/domains/catalog/interfaces/unstable/sub-entities/MetafieldsRequest';
import { MetafieldsSelected } from '../../pages/components/Variants/types';

export type MetafieldsRequest =
  | UpsertMetafieldsRequest
  | DeleteMetafieldsRequest;

export const generateMetafieldsPayload = (
  originalMetafields: MetafieldsSelected | undefined,
  newMetafields: MetafieldSelectedsOrErrorListV2Type | undefined,
): { metafields: MetafieldsRequest[] } | undefined => {
  if (
    !newMetafields ||
    !originalMetafields ||
    originalMetafields?.fromApi === 'error' ||
    originalMetafields?.internals === 'error'
  ) {
    return undefined;
  }
  if (
    newMetafields.fromApi === 'error' ||
    newMetafields.internals === 'error'
  ) {
    return undefined;
  }
  const metafieldsToUpsert: UpsertMetafieldsRequest[] = [];
  const metafieldsToDelete: DeleteMetafieldsRequest[] = [];

  const allOriginalMetafields: MetafieldSelectedV2Dto[] = [
    ...originalMetafields.fromApi,
    ...originalMetafields.internals,
  ];
  const allNewMetafields: MetafieldSelectedV2Dto[] = [
    ...newMetafields.fromApi,
    ...newMetafields.internals,
  ];

  allNewMetafields.forEach((metafield) => {
    if (metafield.value === null) {
      metafieldsToDelete.push({
        uuid: metafield.id,
        '@delete': true,
      });
    } else {
      const originalMetafield = allOriginalMetafields.find(
        (m) => m.id === metafield.id,
      );
      if (!originalMetafield || originalMetafield.value !== metafield.value) {
        const metafieldToUpsert = {
          uuid: metafield.id,
          value: metafield.value ?? '',
        };
        metafieldsToUpsert.push(metafieldToUpsert);
      }
    }
  });

  return { metafields: [...metafieldsToUpsert, ...metafieldsToDelete] };
};
